module.exports = __webpack_public_path__ + "img/left.be5030ca.webp";